export const truncateString = (str, maxLength) => {
    if (str.length <= maxLength) {
      return str;
    }

    const halfLength = Math.floor((maxLength - 3) / 2);
    const start = str.substring(0, halfLength);
    const end = str.substring(str.length - halfLength);

    return `${start}...${end}`;
  };
